(function () {
    'use strict';

    angular
        .module('app', [
            'ui.router', // @uirouter/angularjs, formerly angular-ui-router
            'ui.select', // ui-select
            'app.accountManagement',
            'mm.foundation', // angular-foundation-6, foundation-sites
            'templates',
            'ngCookies', // angular-cookies
            'ngSanitize', // angular-sanitize
            'ngIdle', // ng-idle
            'app.learnAboutThisPage'
        ]);

    angular
        .module('app')
        .run(['$rootScope',
            function ($rootScope) {
                $rootScope.$on('$viewContentLoaded', function () {
                    $(document).foundation();
                });
            }
        ])
        // Used for ui-select, from: http://angular-ui.github.io/ui-select/demo-basic.html
        .filter('propsFilter', function () {
            return function (items, props) {
                var out = [];

                if (angular.isArray(items)) {
                    var keys = Object.keys(props);

                    items.forEach(function (item) {
                        var itemMatches = false;

                        for (var i = 0; i < keys.length; i++) {
                            var prop = keys[i];
                            var text = props[prop].toLowerCase();
                            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                                itemMatches = true;
                                break;
                            }
                        }

                        if (itemMatches) {
                            out.push(item);
                        }
                    });
                } else {
                    // Let the output be the input untouched
                    out = items;
                }

                return out;
            };
        })
        .config(['uiSelectConfig', function (uiSelectConfig) {
            uiSelectConfig.theme = 'bootstrap';
        }])

        .config(['IdleProvider', 'TitleProvider', function (IdleProvider, TitleProvider) {
            IdleProvider.autoResume('notIdle');
            TitleProvider.enabled(false);
        }])

        // Configure Idle service (https://github.com/HackedByChinese/ng-idle) and begin watching for idleness if user is already authenticated.
        //Moved to accountManagement due to authentication
        .run(['Idle', 'Keepalive', 'authentication', 'config', function (Idle, Keepalive, authentication, config) {

            Idle.watch();
       }])
        .config(['uiSelectConfig', function (uiSelectConfig) {
            uiSelectConfig.theme = 'bootstrap';
        }])
        .config(['$locationProvider', function ($locationProvider) {
            $locationProvider.html5Mode(true);
        }]);

    angular
        .module('app.auth', [
            'angularMoment', // angular-moment
            'mm.foundation' // angular-foundation-6
        ]);

    angular
        .module('templates', []);
})();